import { Directive, HostListener, ElementRef, Input } from '@angular/core'

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'textarea[autoresize]'
})
export class AutoResizeTextAreaDirective {
  @HostListener('input', ['$event'])
  resize () {
    const element = this.reference.nativeElement
    element.style.cssText = 'height:auto; padding:0'
    element.style.cssText = 'height:' + element.scrollHeight + 'px'
  }

  constructor(
    private reference: ElementRef<HTMLTextAreaElement>
  ) { }

}
